var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<modal modal-title=\"{{::$ctrl.title}}\" on-dismiss=\"$ctrl.$dismiss('cancel')\" class=\"register-retailer-modal\"><modal-body><register-consumer retailer=\"$ctrl.consumer\"></register-consumer></modal-body><modal-footer></modal-footer></modal>";
var id1="register-consumer.prompt.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;